import { List, Spinner } from "@snapchat/snap-design-system";
import { type FC } from "react";
import { LoadMore, Visible } from "../../common/components";
import { scrollableContainer } from "../../common/styles";
import { Flexbox } from "../../core/components";
import { NoResults } from "../../groups/components/NoResults";
import { LensSourcesListItem } from "../components/LensSourceListItem";
import { type SourceModel } from "../models";

interface LensSourceListProps {
    sources: readonly SourceModel[];
    loading: boolean;
    toggleSelection: (source: SourceModel) => void;
    selectedItems: ReadonlyMap<string, SourceModel>;
    loadMore: () => void;
    isLastPage: boolean;
}

export const LensSourceList: FC<LensSourceListProps> = ({
    sources,
    loading,
    loadMore,
    toggleSelection,
    selectedItems,
    isLastPage,
}) => (
    <div className={scrollableContainer}>
        <Visible when={sources.length === 0 && !loading}>
            <NoResults description="No Lens Sources" />
        </Visible>
        <Visible when={loading}>
            <Flexbox justifyContent="center">
                <Spinner />
            </Flexbox>
        </Visible>
        <List>
            {sources.map((source) => (
                <List.Item key={source.id}>
                    <LensSourcesListItem
                        source={source}
                        onClick={toggleSelection}
                        isSelected={selectedItems.has(source.id)}
                    />
                </List.Item>
            ))}
        </List>
        <Visible when={sources.length > 0}>
            <LoadMore onClick={loadMore} loading={loading} isLastPage={isLastPage} />
        </Visible>
    </div>
);
